module.exports = __webpack_public_path__ + "static/media/commcrypt.b404c1ad.png";